import React, {useState, useEffect} from 'react';
import {Tooltip} from "primereact/tooltip";
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Dropdown} from "primereact/dropdown";
import {InputNumber} from "primereact/inputnumber";
import {BlockUI} from "primereact/blockui";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import FormLocker from "../../util/FormLocker";

const _FM_UnitFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  const [formData, setFormData] = useState({
    number_of_double_beds: 0,
    number_of_single_beds: 0,
    number_of_extra_beds: 0,
  });
  const [newFormData, setNewFormData] = useState({});
  const [category, setCategory] = useState([]);
  const [unit, setUnit] = useState([]);
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "residential-unit/" + formData.id,
        newFormData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data);
          setNewFormData({})
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderUnitList: Math.random(),
            rerenderBerthList: Math.random(),
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "residential-unit",
        formData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderUnitList: Math.random(),
            rerenderBerthList: Math.random(),
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  useEffect(() => {
    let categoryQuery = ''
    // if (localStorage.getItem('selectedAccommodation')) {
    //   categoryQuery = '?search[accommodation]=' + localStorage.getItem('selectedAccommodation')
    // }
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + 'residential-category' + categoryQuery,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setCategory(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    let unitQuery = ''
    // if (localStorage.getItem('selectedAccommodation')) {
    //   unitQuery = '&search[accommodation]=' + localStorage.getItem('selectedAccommodation')
    // }
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "residential-unit?search[has_parent]=0" + unitQuery,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setUnit(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if (window.App.urlVars().unitId || id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "residential-unit/" + (window.App.urlVars().unitId ?? id),
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [])

  useEffect(() => {
    if (window.App.state.selectedCategory) {
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "residential-category/" + window.App.state.selectedCategory,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setFormData({
            ...formData,
            residential_category: window.App.state.selectedCategory,
            building: response?.data?.data?.accommodation?.buildings[0].id,
            parent: window.App.state.selectedUnit,
            number_of_single_beds: response?.data?.data?.number_of_single_beds,
            number_of_double_beds: response?.data?.data?.number_of_double_beds
          })
          window.App.setState({
            selectedUnit: null
          })
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [window.App.state.selectedCategory])

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                  <h2 className={"p-m-0"}>{t('unit_form')}</h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  <Button type="submit" aria-label={t('save_and_close')}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: true}
                          }}
                          className="p-button-success p-ml-2">
              <span>
                <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
              </span>
                  </Button>
                  <Button type="button"
                          icon={"pi pi-times"}
                          onClick={() => {
                            navigate(-1)
                          }}
                          className="p-button-secondary close p-ml-2">
                  </Button>
                </div>
              </div>
              {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
              <HelpComponent type={"edit_box"}/>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6"}>
                  <Field name="name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"name"}/>
                      <label htmlFor="name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('name')}</label>
                      <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-3"}>
                  <Field name="parent" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"parent"}/>
                      <label htmlFor="parent"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('parent')}</label>
                      <span className="">
                      <Dropdown  options={unit}
                                disabled={window.location.hash.toString().includes('#/builder')}
                                optionLabel="name"
                                optionValue="id"
                                filter
                                id={"parent"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    parent: e.value,
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    parent: e.value,
                                  })
                                }}
                                value={formData.parent}
                                showClear
                      />
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-3"}>
                  <Field name="residential_category" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"residential_category"}/>
                      <label htmlFor="residential_category"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('residential_category')}</label>
                      <span className="">
                      <Dropdown  options={category}
                                disabled={window.location.hash.toString().includes('#/builder')}
                                optionLabel="name"
                                optionValue="id"
                                filter
                                id={"residential_category"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  axios({
                                    method: 'get',
                                    url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "residential-category/" + e.value,
                                    params: {},
                                    headers: {
                                      'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                      "Sys-name": Cookies.get("instanceId"),
                                      "Preferred-locale": Cookies.get("language")
                                    }
                                  })
                                    .then(response => {
                                      setFormData({
                                        ...formData,
                                        residential_category: e.value,
                                        building: response.data.data.accommodation?.buildings[0]?.id,
                                        number_of_single_beds: response?.data?.data?.number_of_single_beds,
                                        number_of_double_beds: response?.data?.data?.number_of_double_beds
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        residential_category: e.value,
                                        building: response.data.data.accommodation?.buildings[0]?.id,
                                        number_of_single_beds: response?.data?.data?.number_of_single_beds,
                                        number_of_double_beds: response?.data?.data?.number_of_double_beds
                                      })
                                    })
                                    .catch(error => {
                                      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                    })
                                }}
                                value={formData?.residential_category?.id || formData.residential_category}
                                showClear
                      />
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="number_of_single_beds" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"number_of_double_beds"}/>
                      <label htmlFor="number_of_double_beds"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('number_of_single_beds')}</label>
                      <span className="p-d-block">
                      <InputText id="number_of_single_beds" {...input}
                                 keyfilter={"num"}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     number_of_single_beds: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     number_of_single_beds: e.target.value
                                   })
                                 }}
                                 value={formData.number_of_single_beds}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="number_of_double_beds" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"number_of_double_beds"}/>
                      <label htmlFor="number_of_double_beds"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('number_of_double_beds')}</label>
                      <span className="p-d-block">
                      <InputText id="number_of_double_beds" {...input}
                                 keyfilter={"num"}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     number_of_double_beds: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     number_of_double_beds: e.target.value
                                   })
                                 }}
                                 value={formData.number_of_double_beds}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="number_of_extra_beds" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"number_of_extra_beds"}/>
                      <label htmlFor="number_of_extra_beds"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('number_of_extra_beds')}</label>
                      <span className="p-d-block">
                      <InputText id="number_of_extra_beds" {...input}
                                 keyfilter={"num"}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     number_of_extra_beds: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     number_of_extra_beds: e.target.value
                                   })
                                 }}
                                 value={formData.number_of_extra_beds}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                {formData.id && formData.accommodation && formData.accommodation.name &&
                  <div className={"p-col-12 p-lg-6"}>
                    <Field name="accommodation" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <HelpComponent type={"field"} field={"status"}/>
                        <label htmlFor="status"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('accommodation')}</label>
                        <span className="p-d-block fake-input">
                          <span className={"p-text-nowrap"}>{formData?.accommodation?.name}<span className={"tt-auto-invoice p-ml-2"} data-pr-tooltip={formData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? t('auto_invoice_tooltip_active') : t('auto_invoice_tooltip_inactive')}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"auto-invoice-icon"} style={{ color: formData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? '#0abb87' : '#dddddd', position: 'relative', bottom: '-3px' }}><path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8" /><path d="M5 21l2.5-1.5L10 21l2.5-1.5L14 21l1.5-1" /><path d="M9 7h6" /><path d="M9 11h4" /><path d="M18 14a3 3 0 1 0 3 3" /><path d="M21 20v-3h-3" /></svg></span><Tooltip target=".tt-auto-invoice"/></span>
                      </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                }
              </div>
            </Panel>
          </form>
        )}/>
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(_FM_UnitFormComponent);
